// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import React from "react";
import { ReactElement } from "react";
import { useTestRunState } from "store/testrun";

const DemoBanner: () => ReactElement | null = () => {
  const testRunState = useTestRunState();

  if (testRunState.testRun?.demoMode) {
    return (
      <Alert severity="success">
        <AlertTitle>DEMO MODE</AlertTitle>
        You are now in demo mode.
      </Alert>
    );
  }
  return null;
};

export default DemoBanner;
